import type { Event } from '../../interface/event';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/libs/axios/api';
import { apiConfig } from '@/config/api';

const getPastEvents = async () => {
  try {
    const {
      data: { data: events },
    } = await api.get<{ data: Event[] }>(apiConfig.routes.events.listPasts);

    return events;
  } catch {
    const {
      data: { data: events },
    } = await api.get<{ data: Event[] }>(
      apiConfig.routes.events.publicListPasts
    );

    return events;
  }
};

export const useGetPastEvents = () =>
  useQuery({
    queryKey: ['events', 'past'],
    queryFn: getPastEvents,
  });
